import React, { Fragment } from "react";

interface MultipleChoiceDataEditorProps {
  baseName: string;
  disabled: boolean;
  multiple: boolean;
  description: string;
  optionList: string[];
  allowUpdates: boolean;
  choices: string[];
}

export const MultipleChoiceDataEditor = (
  props: MultipleChoiceDataEditorProps,
) => {
  const {
    baseName,
    disabled,
    multiple,
    description,
    optionList,
    allowUpdates,
    choices,
  } = { ...props };
  // Basic implementation of Razor's HtmlHelper.IdFor:
  // Replaces . and [ and ] with _ for use in an id attribute
  const id = baseName.replace(/[[.\]]/g, "_");

  return (
    <div className="flex space-x-3 post-component multiplechoicecomponent">
      <img
        src="/Content/Images/ic_tag.png"
        className="groopit-component-icon-sm"
      />
      <div>
        <input
          type="hidden"
          name={`${baseName}.Multiple`}
          value={multiple ? "true" : "false"}
        />
        <label className="text-display-normal text-color-secondary">
          {description}
        </label>
        <div id={`optionlist-${id}`} data-namefor={`${baseName}.OptionList`}>
          {optionList.map((option, i) => (
            <input
              key={i}
              type="hidden"
              name={`${baseName}.OptionList[${i}]`}
              value={option}
            />
          ))}
        </div>
        <div id={`btncontainer-${id}`} data-toggle="buttons">
          {optionList.map((option, i) => (
            <Fragment key={i}>
              <label
                className={`btn btn-tag text-break-words ${
                  choices.some((c) => c === option) && "active"
                } ${disabled && "disabled"} ${!multiple && "singlechoice"}`}
              >
                <input
                  type={multiple ? "checkbox" : "radio"}
                  name={`${baseName}.Choices`}
                  value={option}
                  autoComplete="off"
                  defaultChecked={choices.some((c) => c === option)}
                />
                {option}
              </label>
            </Fragment>
          ))}
          {allowUpdates && (
            <label
              id={`btn-${id}`}
              className={`btn toggle ${disabled && "disabled"}`}
              htmlFor={`newchoice-${id}`}
            >
              <img src="/Content/Images/add.png" className="w-4" />
            </label>
          )}
        </div>
        {allowUpdates && (
          <input
            id={`newchoice-${id}`}
            type="text"
            className="form-control newchoice"
            disabled={disabled}
            style={{ display: "none" }}
            placeholder="Add New Option"
            data-type={multiple ? "checkbox" : "radio"}
            data-name={`${baseName}.Choices`}
            data-target={`#btn-${id}`}
            data-optionlist={`#optionlist-${id}`}
          ></input>
        )}
      </div>
    </div>
  );
};
